import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle, faChevronCircleDown, faEye, faEyeSlash, faPaperPlane, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { LoaderService } from './loader/loader.service';
import { ResetPasswordCheckComponent } from './reset.password.check.component';
import { ResetPasswordComponent } from './reset.password.component';
import { ResetPasswordErrorComponent } from './reset.password.error.component';
import { ResetPasswordSentComponent } from './reset.password.sent.component';
import { ResetPasswordUpdatedComponent } from './reset.password.updated.component';
import { SignupComponent } from './signup.component';
import { SignupConfirmedComponent } from './signup.confirmed.component';
import { SignupErrorComponent } from './signup.error.component';
import { SignupSucceedComponent } from './signup.succeed.component';
import { VerifyPasswordErrorComponent } from './verify.password.error.component';


@NgModule({
  declarations: [
    AppComponent,
    SignupComponent,
    SignupSucceedComponent,
    SignupConfirmedComponent,
    SignupErrorComponent,
    ResetPasswordComponent,
    ResetPasswordCheckComponent,
    ResetPasswordSentComponent,
    ResetPasswordUpdatedComponent,
    VerifyPasswordErrorComponent,
    ResetPasswordErrorComponent,
    LoaderComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,

    // awesome font
    FontAwesomeModule,

    ReactiveFormsModule, FormsModule,
    MatButtonModule, MatInputModule,

  ],
  providers: [
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components

    //  library.addIcons(faUpload);

    library.addIcons(faPaperPlane);
    library.addIcons(faCheckCircle);
    library.addIcons(faUserLock);
    library.addIcons(faEyeSlash);
    library.addIcons(faEye);
    library.addIcons(faChevronCircleDown);
  }
}
